import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import useFeatureFlags from './useFeatureFlags';

const useUserInfo = () => {
  const { ttsUser: ttsUserInfo } = useSelector((state) => state.user);
  const { user } = useSelector((state) => state.auth);

  const { getFeatureValue } = useFeatureFlags();
  const useUsageOptions = getFeatureValue(
    FEATURE_KEYS.USE_USAGE_OPTIONS_IN_PACKAGE,
    { userId: user.id, packageCode: user.packageCode },
  );

  const MAPPING_FIELDS = ['maxCloningVoices', 'maxDevices'];
  const MAPPING_PACKAGE_FIELDS = ['features'];

  const ttsUser = useMemo(() => {
    const studioUsageOptions = user?.studioUsageOptions || {};

    if (useUsageOptions) return { ...ttsUserInfo, ...studioUsageOptions };

    const filteredUserFields = MAPPING_FIELDS.reduce((acc, field) => {
      if (user && user[field] !== undefined) {
        acc[field] = user[field];
      }
      return acc;
    }, {});

    const filteredPackageFields = MAPPING_PACKAGE_FIELDS.reduce(
      (acc, field) => {
        if (studioUsageOptions?.[field] !== undefined)
          acc[field] = studioUsageOptions[field];

        return acc;
      },
      {},
    );
    return { ...ttsUserInfo, ...filteredUserFields, ...filteredPackageFields };
  }, [ttsUserInfo, useUsageOptions, user]);

  return { ttsUser };
};
export default useUserInfo;
